import { MutationTree } from "vuex";
import { Poste, PosteMutations, PosteState } from "./interface";
import { PosteMutationsTypes } from "./types";
import { store } from "@/store/store";
import { DeviceActionsTypes } from "../Device/types";

export const mutations: MutationTree<PosteState> & PosteMutations = {
  [PosteMutationsTypes.SET_POSTE](state: PosteState, payload: Array<Poste>): void {
    payload.forEach((role) => {
      if (state.PosteById[role._id] === undefined) {
        state.PosteById[role._id] = role;
        state.PosteAllId.push(role._id);
      }
    });
  },
  [PosteMutationsTypes.UPDATE_POSTE](state: PosteState, payload: Poste): void {
    const new_material_data = payload;
    const old_material_data = state.PosteById[payload._id];
    if (old_material_data.material) store.dispatch(DeviceActionsTypes.GET_DEVICE, old_material_data.material);
    store.dispatch(DeviceActionsTypes.GET_DEVICE, new_material_data.material);
    state.PosteById[payload._id] = payload;
    state.PosteAllId.splice(state.PosteAllId.lastIndexOf(payload._id), 1);
    state.PosteAllId.push(payload._id);
  },
  [PosteMutationsTypes.DELETE_POSTE](state: PosteState, poste_id: string): void {
    delete state.PosteById[poste_id];
    state.PosteAllId.splice(state.PosteAllId.lastIndexOf(poste_id), 1);
  },
  [PosteMutationsTypes.CREATE_POSTE](state: PosteState, payload: Poste): void {
    const new_poste_data = payload;
    if (new_poste_data.material) {
      store.dispatch(DeviceActionsTypes.GET_DEVICE, new_poste_data.material);
    }
    state.PosteById[new_poste_data._id] = new_poste_data;
    state.PosteAllId.push(new_poste_data._id);
  }
};
